const StatusTypeField = ({ item, forTable }) => {
  if (forTable) {
    return (
      <div>
        {item.value == 'archived'
          ? 'Утилизирован'
          : item.value == 'packed'
            ? 'В хранилище'
            : 'Извлечен'}
      </div>
    );
  }
  return null;
};

export default StatusTypeField;
